export const GET_GEOGRAPHIC = 'GET_GEOGRAPHIC';
export const SET_GEOGRAPHIC = 'SET_GEOGRAPHIC';
export const GET_COUNTRYCONFIG = 'GET_COUNTRYCONFIG';
export const SET_COUNTRYCONFIG = 'SET_COUNTRYCONFIG';